import { ReactElement } from 'react';
import classnames from 'classnames';

import styles from './CheckboxInputAccessible.module.scss';

interface iProps {
  title: string;
  disabled?: boolean;
  state: boolean;
  setState: (e: boolean) => void;
}

const Checkbox = ({ title, disabled, state, setState }: iProps): ReactElement => (
  <>
    <div className={styles.container}>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={styles.inputContainer}>
        <input
          type="checkbox"
          id="checkbox"
          className={styles.checkbox}
          onKeyDown={(e) => {
            if (e.key === ' ') {
              setState(!state);
            }
          }}
          onChange={() => {
            setState(!state);
          }}
          checked={state}
          disabled={disabled}
        />
        <span className={styles.body}>{title}</span>
        <span className={classnames({ [styles.tickContainer]: true, [styles.tickContainerstate]: state })} />
      </label>
    </div>
  </>
);

Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
